// Vendor imports
const Cookies = require('js-cookie')
// Client lib imports
const cookieLib = require('client/lib/cookie')

const DISMISS_LINK_MODAL = 'LINK_MODAL_DISMISS'

function dismiss() {
  return function (dispatch) {
    setDismissedCookie()
    dispatch({ type: DISMISS_LINK_MODAL })
  }
}

// Helpers

function setDismissedCookie() {
  Cookies.set(
    'link-modal-dismissed',
    '1',
    cookieLib.setAttributes('link-modal-dismissed')
  )
}

module.exports = {
  DISMISS_LINK_MODAL,
  dismiss
}
